import React, { useState, useEffect } from 'react';
import { Field, Formik, Form } from 'formik';
import { TextArea, RenderIf, Checkbox1, ToggleSwitch } from '../../../../components';
import { CASE_TYPE } from '../../../../utils/enum';
import { cancelCaseSubmission, formikRefCapture, isCaseSaved, storeLiablityEstern } from '../../../../redux/actions/liabilty';
import { useSelector, useDispatch } from 'react-redux';
import CaseReportFilesForm from "./CaseReportFilesForm";
import XMultiImageUpload from "./XMultiImageUpload";
import { handleEnterKeyPress } from "../../../../utils/handleEnterKey";
import { generateRandomIds, getDefendantId } from '../../../../utils/helper';
import CaseFormFooter from "../../../../components/ui-control/CaseFormFooter";


const LiabilityAnalysisForm = ({ onSubmit, stepDecrement, backToCases, innerRef,defendants,selectedDefendant, formSteps }) => {
    const caseInfo = useSelector(state => state.caseInformation.caseData);
    const caseType = caseInfo?.caseInfo?.caseType
    const isSingleLiabilitySectionForAllDefendants = caseInfo?.caseInfo?.isSingleLiabilitySectionForAllDefendants || false;
    const dispatch = useDispatch();
    const liability = useSelector(state => state.liability.liability);
    const [accidentSceneFiles, setAccidentSceneFiles] = useState([]);
    const [productImageFiles, setProductImageFiles] = useState([]);
    const [formValues, setFormValues] = useState({})
    useEffect(() => {
        dispatch(formikRefCapture(innerRef))
    }, [])

    useEffect(() => {
        if (liability) {
            setFormValues(liability);
            setProductImageFiles(liability?.productImageFiles || [])
            setAccidentSceneFiles(liability?.accidentSceneFiles || [])
        }
    }, [liability]);


    const removefile = (formik,key,fileToRemove) => {
        const currentArray = formik?.values?.[key] || [];
        const updatedArray = currentArray.filter(file => file !== fileToRemove);
        formik.setFieldValue(key, updatedArray);
    };

    const productImageFileOnChange = (files) => {
        setProductImageFiles(files)
    }

    const accidentSceneFilesOnChange = (data) => {
        setAccidentSceneFiles(data)
    }

    const fileUploadFunc = (formik, fileKey, files) => {
        const prevFiles = formik.values[fileKey] || [];
        const arr = files?.file.map(elem=>{
            return {
                id : generateRandomIds(),
                file : elem,
                defendants : [
                    getDefendantId(defendants[selectedDefendant])
                ]
            }
        }) 
        const combinedArr = [...prevFiles, ...arr];
        formik.setFieldValue(fileKey, combinedArr);
    }

    const saveDataToStore = (values = {}) => {
        const updatedFormValues = {
            ...values || {},
            accidentSceneFiles,
            productImageFiles,
        };
        dispatch(storeLiablityEstern(updatedFormValues));
        return updatedFormValues
    }

    const handlePrevious = (values) => {
        saveDataToStore(values);
        stepDecrement();
    };

    const updateDefData = (formik,fieldKey, fileId=null,defId=null,isChecked)=>{
        const prevFiles = formik.values[fieldKey] || [];
        prevFiles.forEach((file)=>{
            const prevID = file?.s3UrlPath ? file._id : file.id 
            if(prevID === fileId){
                if(isChecked){
                    file.defendants.push(defId);
                }else{
                    file.defendants = file.defendants.filter((def)=>def !==defId)
                }
            }
        })
        formik.setFieldValue(fieldKey, prevFiles);
    }

    const handleCopyText= (value)=>{
        navigator.clipboard.writeText(value)
    }

    const initDefendantArray = (key) =>{
        return Array.from({ length: defendants.length }, (_, i) => formValues?.[key]?.[i] || { text: "", defendants: [defendants[i].defendantId] })
    };

    const isSingleLiabilitySectionForAllDefendantsToggler = (e, formik) => {
        formik.setFieldValue('isSingleLiabilitySectionForAllDefendants', e.target.checked)
    }

    return (
        <Formik
            initialValues={{
                policeReportData: formValues?.policeReportData ? formValues.policeReportData : [],
                incidentReports: formValues?.incidentReports ? formValues.incidentReports : [],
                witnessStatements:  formValues?.witnessStatements ? formValues.witnessStatements : [],
                expertSafetyReport: formValues?.expertSafetyReport ? formValues.expertSafetyReport : [],
                howincidentOccured: initDefendantArray("howincidentOccured"),
                dangerousConditions: initDefendantArray("dangerousConditions"),
                factsRegardingNotice: initDefendantArray("factsRegardingNotice"),
                factsFailureClaim: initDefendantArray("factsFailureClaim"),
                factsManufacturingDefect: initDefendantArray("factsManufacturingDefect"),
                factsConsumerExpectation: initDefendantArray("factsConsumerExpectation"),
                factsRiskBenefit: initDefendantArray("factsRiskBenefit"),
                isSingleLiabilitySectionForAllDefendants: isSingleLiabilitySectionForAllDefendants,
            }}
            enableReinitialize={true}
            onSubmit={async (values) => {
                dispatch(cancelCaseSubmission(true))
                dispatch(isCaseSaved(false))
                // setFormValues(values)
                const updatedFormValues = saveDataToStore(values);
                onSubmit({
                    liability: updatedFormValues,
                    isDraftCase: false
                })
            }}
        >
            {(formik) => (
                <Form
                    onKeyDown={(e) => handleEnterKeyPress(e)}
                >
                    <div className="add-form p-0">
                        <div className="accordion form-background form-item-pd" id="accordionExample">
                            <div className="d-flex justify-content-between align-items-center w-100 me-3 mb-3">
                                <h2>Reports & Statements</h2>
                            </div>
                            <Field
                                name="isSingleLiabilitySectionForAllDefendants"
                                label="Process all defendants in single liability section"
                                position="left"
                                onChange={(e) => isSingleLiabilitySectionForAllDefendantsToggler(e, formik)}
                                component={ToggleSwitch}
                            />
                            <RenderIf shouldRender={caseType !== CASE_TYPE.AUTO_ACCIDENT}>
                                <div className="row mb-10">
                                    <RenderIf shouldRender={CASE_TYPE.DOG_BITE === caseType}>
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <div className="form-group">
                                                    <Field name={`howincidentOccured[${selectedDefendant}].text`} label="Describe how the Incident occurred" component={TextArea} height={7}
                                                        handleCopyText={() => { handleCopyText(formik.values.howincidentOccured?.[selectedDefendant]?.text); }} />
                                                </div>
                                            </div>
                                        </div>
                                    </RenderIf>
                                    <RenderIf shouldRender={[CASE_TYPE.TRIP_AND_FALL, CASE_TYPE.SLIP_AND_FALL, CASE_TYPE.PREMISE_LIABILITY].includes(caseType)}>
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <div className="form-group">
                                                    <Field name={`howincidentOccured[${selectedDefendant}].text`} label="Describe how the Incident occurred" component={TextArea} height={7}
                                                        handleCopyText={() => { handleCopyText(formik.values.howincidentOccured?.[selectedDefendant]?.text); }} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <div className="form-group">
                                                    <Field name={`dangerousConditions[${selectedDefendant}].text`} label="Describe The Dangerous Conditions" component={TextArea} height={7}
                                                        handleCopyText={() => { handleCopyText(formik.values.dangerousConditions?.[selectedDefendant]?.text); }} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <div className="form-group">
                                                    <Field name={`factsRegardingNotice[${selectedDefendant}].text`} label="State Any Facts Regarding Notice" component={TextArea} height={7}
                                                        handleCopyText={() => { handleCopyText(formik.values.factsRegardingNotice?.[selectedDefendant]?.text); }} />
                                                </div>
                                            </div>
                                        </div>
                                    </RenderIf>
                                    <RenderIf shouldRender={caseType === CASE_TYPE.PRODUCT_LIABILITY}>
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <div className="form-group">
                                                    <Field name={`howincidentOccured[${selectedDefendant}].text`} label="Describe how the Incident occurred" component={TextArea} height={7}
                                                        handleCopyText={() => { handleCopyText(formik.values.howincidentOccured?.[selectedDefendant]?.text); }} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <div className="form-group">
                                                    <Field name={`factsFailureClaim[${selectedDefendant}].text`} label="Facts to support failure to warn claims" component={TextArea} height={7}
                                                        handleCopyText={() => { handleCopyText(formik.values.factsFailureClaim?.[selectedDefendant]?.text); }} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <div className="form-group">
                                                    <Field name={`factsManufacturingDefect[${selectedDefendant}].text`} label="Facts to support a manufacturing defect " component={TextArea} height={7}
                                                        handleCopyText={() => { handleCopyText(formik.values.factsManufacturingDefect?.[selectedDefendant]?.text); }} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <div className="form-group">
                                                    <Field name={`factsConsumerExpectation[${selectedDefendant}].text`} label="Facts to support consumer expectation test" component={TextArea} height={7}
                                                        handleCopyText={() => { handleCopyText(formik.values.factsConsumerExpectation?.[selectedDefendant]?.text); }} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <div className="form-group">
                                                    <Field name={`factsRiskBenefit[${selectedDefendant}].text`} label="Facts to support risk-benefit test" component={TextArea} height={7}
                                                        handleCopyText={() => { handleCopyText(formik.values.factsRiskBenefit?.[selectedDefendant]?.text); }} />
                                                </div>
                                            </div>
                                        </div>
                                    </RenderIf>
                                </div>
                            </RenderIf>
                            <div className="row mb-10">
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <RenderIf shouldRender={caseType === CASE_TYPE.AUTO_ACCIDENT}>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <div className="form-group">
                                                        <Field name={`howincidentOccured[${selectedDefendant}].text`} label="Describe how the Incident occurred" component={TextArea} height={7}
                                                            handleCopyText={() => { handleCopyText(formik.values.howincidentOccured?.[selectedDefendant]?.text); }} />
                                                    </div>
                                                </div>
                                            </div>
                                            <CaseReportFilesForm
                                                onFileSelected={(files) => {
                                                    fileUploadFunc(formik, "policeReportData", files);
                                                }}
                                                fileNames={formik.values?.policeReportData?.length > 0 ? formik.values?.policeReportData : []}
                                                fieldName='policeReportData'
                                                documentName='policeReportData'
                                                reportName='Police Report'
                                                removeFile={(file) => removefile(formik, "policeReportData", file)}
                                                uploadButtonText='Upload Report'
                                                defendants={defendants}
                                                updateFileData={((fileId = null, defId = null, isChecked) => {
                                                    updateDefData(formik, "policeReportData", fileId, defId, isChecked)
                                                })}
                                                isRenderLiabilityFiles= {true}
                                            />
                                        </RenderIf>
                                        <RenderIf shouldRender={[CASE_TYPE.TRIP_AND_FALL, CASE_TYPE.PRODUCT_LIABILITY, CASE_TYPE.SLIP_AND_FALL, CASE_TYPE.PREMISE_LIABILITY, CASE_TYPE.DOG_BITE, CASE_TYPE.AUTO_ACCIDENT].includes(caseType)}>
                                            <CaseReportFilesForm
                                                onFileSelected={(files) => {
                                                    fileUploadFunc(formik, "witnessStatements", files);
                                                }}
                                                fileNames={formik.values?.witnessStatements?.length > 0 ? formik.values?.witnessStatements : []}
                                                fieldName='witnessStatements'
                                                documentName='witnessStatements'
                                                reportName='Witness Statement'
                                                removeFile={(file) => removefile(formik, "witnessStatements", file)}
                                                uploadButtonText='Upload Statement'
                                                defendants={defendants}
                                                selectedDefendant={selectedDefendant}
                                                updateFileData={((fileName = null, defId = null, isChecked) => {
                                                    updateDefData(formik, "witnessStatements", fileName, defId, isChecked)
                                                })}
                                                isRenderLiabilityFiles= {true}
                                            />
                                        </RenderIf>
                                        <RenderIf shouldRender={[CASE_TYPE.TRIP_AND_FALL, CASE_TYPE.SLIP_AND_FALL, CASE_TYPE.PREMISE_LIABILITY, CASE_TYPE.DOG_BITE, CASE_TYPE.PRODUCT_LIABILITY].includes(caseType)}>
                                            <CaseReportFilesForm
                                                onFileSelected={(files) => {
                                                    fileUploadFunc(formik, "incidentReports", files);
                                                }}
                                                fileNames={formik.values?.incidentReports?.length > 0 ? formik.values?.incidentReports : []}
                                                fieldName='incidentReports'
                                                documentName='incidentReports'
                                                reportName='Incident Reports'
                                                removeFile={(file) => removefile(formik, "incidentReports", file)}
                                                uploadButtonText='Upload Report'
                                                defendants={defendants}
                                                selectedDefendant={selectedDefendant}
                                                updateFileData={((fileName = null, defId = null, isChecked) => {
                                                    updateDefData(formik, "incidentReports", fileName, defId, isChecked)
                                                })}
                                                isRenderLiabilityFiles= {true}
                                            />
                                        </RenderIf>
                                        <RenderIf shouldRender={[CASE_TYPE.TRIP_AND_FALL, CASE_TYPE.PRODUCT_LIABILITY, CASE_TYPE.SLIP_AND_FALL, CASE_TYPE.PREMISE_LIABILITY].includes(caseType)}>
                                            <CaseReportFilesForm
                                                onFileSelected={(files) => {
                                                    fileUploadFunc(formik, "expertSafetyReport", files);
                                                }}
                                                fileNames={formik.values?.expertSafetyReport?.length > 0 ? formik.values?.expertSafetyReport : []}
                                                fieldName='expertSafetyReport'
                                                documentName='expertSafetyReport'
                                                reportName='Expert Safety Report'
                                                removeFile={(file) => removefile(formik, "expertSafetyReport", file)}
                                                uploadButtonText='Upload Report'
                                                defendants={defendants}
                                                selectedDefendant={selectedDefendant}
                                                updateFileData={((fileName = null, defId = null, isChecked) => {
                                                    updateDefData(formik, "expertSafetyReport", fileName, defId, isChecked)
                                                })}
                                                isRenderLiabilityFiles= {true}
                                            />
                                        </RenderIf>
                                    </div>
                                </div>
                            </div>
                            <RenderIf shouldRender={[CASE_TYPE.AUTO_ACCIDENT, CASE_TYPE.TRIP_AND_FALL, CASE_TYPE.SLIP_AND_FALL, CASE_TYPE.PREMISE_LIABILITY, CASE_TYPE.DOG_BITE].includes(caseType)}>
                                <div className="d-flex justify-content-between align-items-center w-100 me-3 mb-3">
                                    <h2>Accident Scene and Property Damage Photos</h2>
                                </div>
                                <div className="row mb-3">
                                    <div className="col-md-12">
                                        <XMultiImageUpload
                                            label="Accident Scene and Property Damage Photos"
                                            name="accidentReportImageFiles"
                                            onChange={accidentSceneFilesOnChange}
                                            initialFiles={accidentSceneFiles}
                                            defendants={defendants}
                                        />
                                    </div>
                                </div>
                            </RenderIf>
                            <RenderIf shouldRender={caseType === CASE_TYPE.PRODUCT_LIABILITY}>
                                <div className="d-flex justify-content-between align-items-center w-100 me-3">
                                    <h2>Accident Scene and Property Damage Photos</h2>
                                </div>
                                <div className="row mb-3">
                                    <div className="col-md-12">
                                        <XMultiImageUpload
                                            label="Attach photographs of Incident (If Available)"
                                            name="productImageFiles"
                                            onChange={productImageFileOnChange}
                                            initialFiles={productImageFiles}
                                        />
                                    </div>
                                </div>
                            </RenderIf>
                        </div>
                        <CaseFormFooter backToCases={backToCases} handlePrevious={handlePrevious} innerRef={innerRef}  formSteps={formSteps} values={formik.values}/>
                    </div>
                </Form>
            )
            }
        </Formik >
    )
}

export default LiabilityAnalysisForm;